import useQueryProposals from "@/modules/property-tracks/hooks/rental-financial-proposal/query-proposals.hook";
import { Box, Typography } from "@mui/material";
import CreateFinancialProposal from "./actions/create";
import { Track } from "@/modules/property-tracks/types";
import FinancialProposalList from "./list";

interface RentalFinancialProposalsProps {
  track: Track;
}

export default function RentalFinancialProposals({
  track,
}: RentalFinancialProposalsProps) {
  const { data, isLoading } = useQueryProposals({ trackUids: [track.uid] });

  return (
    <Box
      sx={(t) => ({
        borderRadius: t.nawy.radius.lg,
        backgroundColor: t.nawy.colors.semantic.layer.primary,
        padding: t.nawy.spacing.md,
        display: "flex",
        flexDirection: "column",
        gap: t.nawy.spacing.sm,
      })}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
        >
          Financial proposals
        </Typography>

        <CreateFinancialProposal
          trackUid={track.uid}
          defaultValues={{
            compoundName: track.property.compound?.name ?? "",
            customerName: track.owner?.name ?? "",
            propertyTypeName: track.property.propertyType?.name ?? "",
            unitArea: track.property.unitArea ?? 0,
            scopeOfFinishing: track.scopeOfFinishing,
          }}
        />
      </Box>
      <FinancialProposalList
        proposals={data}
        isLoading={isLoading}
        customerUId={track.owner?.uid ?? ""}
      />
    </Box>
  );
}
